module.exports = tripTracking;